import React from 'react';
export function Footer() {
  return <footer className="py-12 px-6 border-t border-[#A39B8B]/10 bg-white" data-id="element-56">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center text-center md:text-left gap-6" data-id="element-57">
        <div data-id="element-58">
          <h4 className="font-bold text-[#8B9D83] text-xl mb-2" data-id="element-59">Welma</h4>
          <p className="text-sm text-[#2D2D2D]/60 max-w-xs" data-id="element-60">
            Welma helps wellness professionals run their practice, every day.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 text-sm text-[#2D2D2D]/60" data-id="element-61">
          <a href="mailto:hello@welma.app" className="hover:text-[#8B9D83] transition-colors" data-id="element-62">
            hello@welma.app
          </a>
          <a href="#" className="hover:text-[#8B9D83] transition-colors" data-id="element-63">
            Privacy Policy
          </a>
          <span data-id="element-64">© {new Date().getFullYear()} Welma</span>
        </div>
      </div>
    </footer>;
}